:root {
	--percentage: -9px;
}

.notesTabpanel {
	display: flex;
	width: 100%;
	flex-wrap: wrap;
	height: 62vh;
	border: 1px solid #e6e0e9;
	border-radius: 10px;
}

.verityAssessmentTopCard {
	display: flex;
	flex-direction: column;
	background-color: #fff;
	width: 100%;
}

.verityTabsWrapper,
.verityAssessmentHeader {
	display: flex;
	min-height: 55px;
	box-sizing: border-box;
	border-bottom: 1.11px solid #f3f4f6;
	padding: 0.75rem 1rem;
	align-items: center;
	width: 100%;
}

.verityAssessmentHeader {
	justify-content: space-between;
	flex-wrap: wrap;
	gap: 0.5rem;
}

.assessmentTitleWrapper {
	display: flex;
	align-items: center;
	gap: 1rem;
	flex-wrap: wrap;
}

.studentSelectorVerity.studentSelectorVerity {
	border-radius: 10px;

	& :global(.MuiOutlinedInput-notchedOutline) {
		border: 1.11px solid #e5e7eb;
	}
}

.studentSelectorLayoutVerity.studentSelectorLayoutVerity {
	padding: unset;
	border-bottom: unset;
	min-height: unset;
}

.saveButtonsWrapper {
	display: flex;
	align-items: center;
	gap: 0.5rem;

	& :global(.MuiButton-root) {
		height: 35px;
		min-width: fit-content;
	}
}

.assessmentInfoContainer {
	display: flex;
	flex-direction: column;
	gap: 10px;
	box-sizing: border-box;
	padding: 0.5rem 1rem;
}

.attemptInfoWrapper {
	display: flex;
	align-items: center;
	gap: 0.5rem;
	flex-wrap: wrap;
}

.verityAtttmptSelector:global(.MuiOutlinedInput-root) {
	max-width: unset;
	width: unset;
	border-radius: 10px;
	width: 200px;

	& :global(.MuiOutlinedInput-notchedOutline) {
		border: 1.11px solid #e5e7eb;
	}
}

.verityAssignmentInstructionsContainer {
	display: flex;
	flex-direction: column;
	gap: 0.325rem;

	& .title {
		color: #333333;
		font-size: 0.875rem;
		line-height: 1.6;
		font-weight: 500;
	}
}

.verityQuizContainer {
	display: flex;
	flex-direction: column;
	box-sizing: border-box;
	height: 100%;
	width: 100%;
}

.mainTabPanelWrapper {
	display: flex;
	flex-direction: column;
	border-bottom: 1.11px solid #e5e7eb;
	gap: 0.625rem;
	padding: 0.625rem;
	box-sizing: border-box;
	width: 100%;
}

.bannerContainer {
	display: flex;
	box-sizing: border-box;
	padding: 0.625rem;
	width: 100%;
}
